import React, { useState } from 'react';
import { GridColumn, GridRow } from 'app/member/layouts/grid';
import { Spacer } from 'app/layouts/generic';
import { Button } from 'app/shared/button';
import { DetailItem } from 'app/shared/info-section/item';
import { SimpleInput } from 'app/shared/input';
import { useTenantService } from 'hooks/api/iam/tenant';

const contactFromTenant = (tenant = {}) => ({
  firstname: tenant.contact?.firstname || '',
  lastname: tenant.contact?.lastname || '',
  email: tenant.contact?.email || '',
  phone_number: tenant.contact?.phone_number || ''
});

export const UpdateContactForm = ({ tenant = {}, onUpdated = () => {}, closeModal = () => {} }) => {
  const { updateTenant } = useTenantService();
  const [form_data, setFormData] = useState(contactFromTenant(tenant));
  const [submitting, setSubmitting] = useState(false);

  const set = (field, value) => setFormData((prev) => ({ ...prev, [field]: value }));

  const handleSubmit = async () => {
    const id = tenant.id || tenant._id;
    if (!id) return;
    const contact = {
      firstname: form_data.firstname.trim(),
      lastname: form_data.lastname.trim(),
      email: form_data.email.trim(),
      phone_number: form_data.phone_number.trim()
    };
    setSubmitting(true);
    const ok = await updateTenant(id, { data: { contact } });
    setSubmitting(false);
    if (ok) {
      onUpdated(contact);
      closeModal();
    }
  };

  return (
    <div>
      <GridRow num_of_columns={2}>
        <GridColumn>
          <DetailItem title="First name">
            <SimpleInput
              value={form_data.firstname}
              onInput={(value) => set('firstname', value)}
              placeholder="Ada"
            />
          </DetailItem>
        </GridColumn>
        <GridColumn>
          <DetailItem title="Last name">
            <SimpleInput
              value={form_data.lastname}
              onInput={(value) => set('lastname', value)}
              placeholder="Obi"
            />
          </DetailItem>
        </GridColumn>
      </GridRow>

      <Spacer multiple={2} />

      <GridRow num_of_columns={1}>
        <GridColumn>
          <DetailItem title="Email">
            <SimpleInput
              value={form_data.email}
              onInput={(value) => set('email', value)}
              placeholder="ada@acme.co"
            />
          </DetailItem>
        </GridColumn>
      </GridRow>

      <Spacer multiple={2} />

      <GridRow num_of_columns={1}>
        <GridColumn>
          <DetailItem title="Phone number">
            <SimpleInput
              value={form_data.phone_number}
              onInput={(value) => set('phone_number', value)}
              placeholder="+234 800 000 0000"
            />
          </DetailItem>
        </GridColumn>
      </GridRow>

      <Spacer multiple={3} />

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
        <Button text="Cancel" type="secondary" onClick={closeModal} />
        <Button text="Save Contact" onClick={handleSubmit} loading={submitting} />
      </div>
    </div>
  );
};

export default UpdateContactForm;
